(function($) { $(document).ready(function() {

    if ($(".how-we-do-this-swiper").length > 0) {
        let box = $('.how-do-we-do-this-box');

        function initSwiper(direction, slidersPrePage, spaceBetween) {
            return new Swiper('.how-we-do-this-swiper', {
                direction: direction,
                freeMode: false,
                slidesPerView: slidersPrePage,
                spaceBetween: spaceBetween,
                pagination: {
                    el: '.swiper-pagination',
                },
            });
        }

        function toggleSwiper() {
            if( $(window).width() < 960){
                let swiper = initSwiper('horizontal', 'auto', 'auto');
                let slideIndex = swiper.activeIndex;

                swiper.destroy(true, true);
                swiper = initSwiper('horizontal', 1, 30);
                swiper.slideTo(slideIndex,0);

                box.each(function () {
                    $(this).find('p').show(200);
                });

                box.off('mouseenter mouseleave');
            } else {
                try {
                    document.querySelector('.how-we-do-this-swiper').swiper.destroy(true, true)
                } catch (e) {
                    // console.log(e);
                }

                box.hover(
                    function () {
                        $(this).find('p').show(200);
                        $(this).removeClass('lg:bg-inherit');
                    },
                    function () {
                        $(this).find('p').hide(200);
                        $(this).addClass('lg:bg-inherit');
                    }
                );
            }
        }

        toggleSwiper();

        $(window).resize(function () {
            toggleSwiper();
        });
    }

}); })( jQuery );